import React from 'react';
import GlobalAppLayout from '../../../molecules/GlobalAppLayout/GlobalAppLayout';

export default function(props)
{
    return <GlobalAppLayout {...props}/>;
}
